<style scoped>
.cover-photo {
  background-color: #ffb0b0;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  z-index: -1;
  padding: 30px 48px;
  display: flex;
  flex-flow: row;
  align-items: flex-end;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

.mask {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  /* background-color: #0000002b; */
  z-index: -1;
}
</style>

<template lang="pug">
  .small
    .cover-photo(:style='{backgroundImage: "url(" + photo + ")"}')
      .container(v-if='shop')
        p.title.large.white-text.no-margin {{shop.name}}
        p.subtitle.small.white-text.no-margin {{shop.location}}
    .mask
</template>
<script>

export default {
  props: ['shop'],
  computed: {
    photo () {
      return this.shop
        ? this.shop.photo.big
        : null
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/page-supplier-details-billboard.vue